import { FC, ReactNode } from 'react';

import { useDelayedRemount } from 'utils/hooks/useDelayedRemount';

import { ErrorBoundary, ErrorBoundaryProps } from './ErrorBoundary';

const ONE_SECOND = 1000;

type RemountableErrorBoundaryProps = {
  errorMarkup: (args: { isRemounting: boolean; remount: () => void }) => ReactNode;
  delay?: number;
} & Omit<ErrorBoundaryProps, 'errorMarkup'>;

export const RemountableErrorBoundary: FC<
  React.PropsWithChildren<RemountableErrorBoundaryProps>
> = ({ children, delay = ONE_SECOND, errorMarkup, ...props }) => {
  const { content } = useDelayedRemount({
    content: ({ isRemounting, remount }) => (
      <ErrorBoundary errorMarkup={errorMarkup({ isRemounting, remount })} {...props}>
        {children}
      </ErrorBoundary>
    ),
    delay,
  });

  return content;
};
